import { gql } from '@apollo/client';

export const GET_ASSETS_QUERY = gql`
    query getAssetListing($ids: String) {
        getAssetListing(ids: $ids) {
            edges {
                node {
                    ... on asset {
                        id
                        fullpath
                        mimetype
                        type
                    }
                }
            }
        }
    }
`;

export function getAssetsQueryVariables(ids: string[]) {
    return {
        ids: ids.join(','),
    };
}
